import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import {SERVER_API_URL} from '../../app.constants';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request || !request.url || (/^http/.test(request.url) && !(SERVER_API_URL && request.url.startsWith(SERVER_API_URL)))) {
            return next.handle(request);
        }

        const isAuthenticate = request.url.includes('/api/authenticate')
            && !request.url.includes('/api/authenticate/clear-path');

        const headers: { [name: string]: string } = {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        };

        // Never attach a stale JWT to login — can cause intermittent auth failures
        if (!isAuthenticate) {
            const token = localStorage.getItem('authenticationToken') || sessionStorage.getItem('authenticationToken');
            if (token) {
                headers['Authorization'] = 'Bearer ' + token;
            }
        }

        request = request.clone({ setHeaders: headers });
        return next.handle(request);
    }
}
